"use strict";const e=require("styled-components").css`
    &.FeaturesGrid {

        .FeaturesGrid-grid {
            display: grid;
            justify-content: stretch;
            align-items: stretch;
            grid-template-columns: 1fr;
            @media (min-width: 422px) {
                grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
            }

            .FeaturesGrid-cta {
                display: flex;
                flex-wrap: nowrap;
                align-items: center;
                justify-content: center;
                width: 100%;
                color: ${({theme:e})=>e.colors.primary.default};
                text-decoration: none;
                font-weight: bold;

                .DXTypography {
                    color: ${({theme:e})=>e.colors.primary.default};
                    margin-left: 10px;
                }
            }
        }
        .FeaturesGrid-mobileNav {
            display: flex;
            justify-content: space-between;
            margin: auto;
            align-items: center;
            @media (min-width: 601px) {
                display: none;
            }
            .FeaturesGrid-scrollBtn {
                svg {
                    &:hover {
                        cursor: pointer;
                    }
                    path {
                        fill: black;
                    }
                }
                &.inactive {
                    visibility: hidden
                }
            }
        }
        &.disabled {
            .FeatureCard.disabled {
                opacity: 0.25;
            }
        }

        .FeaturesGrid-btn {
            width: 100%;
            text-align: center;
            margin-top: ${({theme:e})=>e.spacing.large};
            margin-bottom: ${({theme:e})=>e.spacing.large};
            text-transform: none;

            button {
                background-color: #0075c9;
                width: fit-content;
            }
        }
    }
`;module.exports=e;
//# sourceMappingURL=styles.js.map
